import { MembershipStatus } from '@kalos/kalos-rpc';
import { useQuery } from '@tanstack/react-query';

import { queryKeys } from '../../../hooks/react-query/constants';
import { MembershipClientService } from '../../../tools/helpers';

// Membership status vocabulary (seeded lookup) as Map<id, value> for resolving membership.status_id.
export const useMembershipStatuses = ({ enabled = true }: { enabled?: boolean } = {}) => {
  return useQuery<Map<number, string>>({
    queryKey: [queryKeys.memberships.root, queryKeys.memberships.statuses],
    enabled,
    // Seeded vocabulary — it doesn't change under a session, so don't refetch it per consumer.
    staleTime: 15 * 60 * 1000,
    queryFn: async () => {
      const filter = MembershipStatus.create({ withoutLimit: true });
      const result = await MembershipClientService.BatchGetMembershipStatus(filter);
      const rows = result?.results ?? [];
      return new Map(rows.map((r) => [r.id, r.value]));
    },
  });
};
